// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"795":"2579cae5","917":"2191fdf9"}[chunkId] + ".chunk.js";
};